// import { RESOLVER_TYPE_COMMUNITY_ACTIVITY } from 'services/resolver/types'
import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { setJumbotronData } from 'services/jumbotron/actions'
import { STORE_KEY_SUBCATEGORY } from 'services/store-keys'
import { BOOTSTRAP_PHASE_COMPLETE } from 'services/app'
import { SET_AUTH_DATA } from 'services/auth/actions'
import { addToasty } from 'services/toasty/actions'
import { isCommunityPage } from 'services/url'
import { map as bluebirdMap } from 'bluebird'
// import { List, fromJS } from 'immutable'
import capitalize from 'lodash/capitalize'
import { get as getConfig } from 'config'
import isString from 'lodash/isString'
import toLower from 'lodash/toLower'
// import filter from 'lodash/filter'
// import reduce from 'lodash/reduce'
// import { Map, List } from 'immutable'
// import map from 'lodash/map'
import get from 'lodash/get'

import * as selectors from './selectors'
import * as actions from './actions'
import * as draft from './draft'
import * as api from './'

/**
 * watcher for Community page visit/load
 * to fetch the main feed data
 */
export function watchPageMount ({ after }) {
  return after([
    SET_APP_BOOTSTRAP_PHASE,
    SET_RESOLVER_DATA,
  ], async ({ state, dispatch }) => {
    const { app, resolver } = state
    if (app.get('bootstrapPhase') === BOOTSTRAP_PHASE_COMPLETE) {
      // const type = resolver.getIn(['data', 'type'])
      const pathname = resolver.getIn(['data', 'path'])

      if (isCommunityPage(pathname)) {
        // sadly, we need to set the static community jumbotron data in the store due to
        // the component requiring the data to be connected,
        // rather than passing the necessary data via prop.
        dispatch(setJumbotronData(STORE_KEY_SUBCATEGORY,
          { description: api.COMMUNITY_PAGE_HERO_TEXT }))
        // dispatch(getFeed({ type: api.FEED_TYPES.MAIN, key: 'main' }))
      }
      // TODO add this back in when we create the activity page
      // else if (type === RESOLVER_TYPE_COMMUNITY_ACTIVITY) {
      //   const id = resolver.getIn(['data', 'params', 'activityId'])
      //   dispatch(actions.getActivity({ id }))
      // }
    }
  })
}

/**
 * watcher for the SET_AUTH_DATA action
 * which fires anytime a login or profile change occurs.
 * for existing logged in users, we hydrate from the server,
 * just like auth and user data, so no need to watch for anything.
 */
export function watchAuthChange ({ after }) {
  return after(SET_AUTH_DATA,
    async ({ state, dispatch, prevState }) => {
      const { auth: prev } = prevState
      const { auth: next } = state
      const nextUuid = next.get('uuid')
      const prevUuid = prev.get('uuid')
      // TODO remove this v2 check with getstream removal
      if (getConfig().features.community.v2 && prevUuid !== nextUuid) {
        dispatch(actions.connectFeed({ id: 'main' })) // do for each feed?
      }
    })
}

/**
 * watcher for connecting a feed
 */
export function watchConnectFeed ({ after }) {
  return after([
    actions.COMMUNITY_CONNECT_FEED,
  ], async ({ state, action, dispatch }) => {
    const { payload } = action
    const { id } = payload
    const { auth } = state
    const data = await api.connectFeed({ id, auth })
    // const uuid = get(data, 'feedUuid')
    dispatch({
      type: actions.COMMUNITY_SET_FEED,
      payload: { data },
    })
  })
}

/**
 * watcher for fetching a feed activities
 */
export function watchFetchFeedActivities ({ after }) {
  return after([
    actions.COMMUNITY_FETCH_ACTIVITIES,
  ], async ({ state, action, dispatch }) => {
    const { payload } = action
    const { feedUuid, activityId } = payload
    const { auth } = state
    // lt: lastActivity.get('uuid') in fetch below
    const data = await api.fetchActivities({ feedUuid, activityId, auth })
    dispatch({
      type: actions.COMMUNITY_SET_ACTIVITIES,
      payload: { data },
    })
  })
}

/**
 * watcher for page change away from Community
 * and will cleanup any data we no longer need in the store
 */
export function watchPageUnmount ({ before }) {
  return before(SET_RESOLVER_DATA, async ({ state, action, dispatch }) => {
    const { resolver } = state
    const next = get(action, 'payload.data.path')
    const path = resolver.getIn(['data', 'path'])
    if (isCommunityPage(path)
      && !isCommunityPage(next)) {
      dispatch(actions.unmountPage())
    }
  })
}

export function watchAddActivity ({ after }) {
  return after(
    actions.COMMUNITY_ADD_ACTIVITY,
    async ({ state, action, dispatch }) => {
      const { community, auth } = state
      const { payload } = action
      const { draftId } = payload
      const activity = selectors.selectDraft(community, draftId)

      if (activity.get('processing')) {
        return
      }

      dispatch(actions.putDraft(
        draftId, draft.setProcessing(activity, true)))

      try {
        // later will take id for feed (we may have more than main)
        const response = await api.addActivity({ auth, activity })
        if (response && global.dataLayer) {
          global.dataLayer.push({
            event: 'customEvent',
            eventCategory: 'community',
            eventAction: 'post',
            eventLabel: response.uuid,
          })
        }
        // const feedUuid = response.parent.uuid
        // const activities = community.getIn(['feeds', feedUuid, 'activities'])
        // const activityId = activities.getIn([activities.size - 1, 'uuid'])
        dispatch(addToasty(`${capitalize(activity.get('type'))} successfully created!`))
        dispatch(actions.deleteDraft(draftId))
        dispatch(actions.fetchActivities({ })) // feedUuid: parent, activityId
      } catch (_) {
        dispatch(addToasty(`Could not create ${toLower(activity.get('type'))}.`))
        dispatch(actions.putDraft(
          draftId, draft.setProcessing(activity, false)))
      }
    })
}


export function watchRemoveActivity ({ after }) {
  return after(
    actions.COMMUNITY_REMOVE_ACTIVITY,
    async ({ state, action, dispatch }) => {
      const { payload } = action
      const { auth } = state
      const { activityId, type } = payload
      try {
        await api.removeActivity({
          activityId,
          auth,
        })
        dispatch(addToasty(`${toLower(type)} successfully deleted!`))
        dispatch(actions.fetchActivities({ feedUuid: parent, activityId }))
      } catch (_) {
        dispatch(addToasty(`Could not delete ${toLower(type)}.`))
      }
    })
}

export function watchAddReaction ({ after }) {
  return after(
    actions.COMMUNITY_ADD_REACTION,
    async ({ state, action, dispatch }) => {
      const { auth } = state // community
      const { payload } = action
      const { uuid, type } = payload

      try {
        const response = await api.addReaction({ auth, activity: uuid, type })
        if (response && global.dataLayer) {
          global.dataLayer.push({
            event: 'customEvent',
            eventCategory: 'community',
            eventAction: 'favorite',
            eventLabel: response.uuid,
          })
        }
        // const feedUuid = response.parent.uuid
        // const activities = community.getIn(['feeds', feedUuid, 'activities'])
        // const activityId = activities.getIn([activities.size - 1, 'uuid'])
        dispatch(addToasty('Reaction successfully created!'))
        dispatch(actions.fetchActivities({ }))
      } catch (_) {
        dispatch(addToasty('Could not create reaction.'))
      }
    })
}

export function watchRemoveReaction ({ after }) {
  return after(
    actions.COMMUNITY_REMOVE_REACTION,
    async ({ state, action, dispatch }) => {
      const { payload } = action
      const { auth } = state
      const { activityUuid } = payload
      try {
        await api.removeReaction({
          activityUuid,
          auth,
        })
        dispatch(addToasty('Reaction successfully deleted!'))
        dispatch(actions.fetchActivities({ })) // todo fetch
      } catch (_) {
        dispatch(addToasty('Could not delete reaction.'))
      }
    })
}

export function watchUpdateDraft ({ after }) {
  return after(
    actions.COMMUNITY_UPDATE_DRAFT,
    async ({ state, action, dispatch }) => {
      const { payload } = action
      const { community } = state
      const { draftId, attributes } = payload
      const { parent, openGraph, photoUpload, photos, type, value } = attributes
      const prev = selectors.selectDraft(community, draftId, parent, type)
      const activityDraft = prev.withMutations((d) => {
        draft.setValue(d, value)
      })

      dispatch(actions.putDraft(
        draftId, activityDraft))

      if (photoUpload && photos && photos.length) {
        dispatch(actions.addDraftPhotos(
          draftId, { photos }))
      }

      if (openGraph && isString(value)) {
        dispatch(actions.addDraftOpenGraphs(
          draftId, { type, value }))
      }
    })
    .catch(() => (
      addToasty('Unable to upload files.')
    ))
}

// export function watchDraftOpenGraph ({ after }) {
//   return after(
//     actions.COMMUNITY_ADD_DRAFT_OPENGRAPHS,
//     async ({ action, dispatch, getState }) => {
//       const { payload } = action
//       const { type, draftId, text } = payload

//       if (isString(text)) {
//         const fallback = draft.createDraft(type)
//         const { community } = getState()

//         let draft = selectors.selectDraft(community, draftId, fallback)
//         const prevOGs = selectors.selectActivityOGs(draft)

//         if (text.length < 1) {
//           const filteredOGs = prevOGs.filter(og => (
//             og.get('render') && og.get('valid')
//           ))
//           draft = draft.setAttachments(draft, 'og', filteredOGs)
//           dispatch(actions.putDraft(draftId, draft))
//           return
//         }

//         const matches = api.parseURLs(text)
//         const nextOGs = reduce(matches, (out, match) => {
//           const src = get(match, 'source')
//           const prev = prevOGs.find(u => (
//             u.get('source') === src
//           ))
//           if (prev) {
//             const locs = get(match, 'locations')
//             const next = prev.set('locations', fromJS(locs))
//             out.push(next)
//           } else {
//             out.push(match)
//           }
//           return out
//         }, [])
//         const ungraphedURLs = filter(matches, ({ source }) => (
//           !prevOGs.find(u => u.get('source') === source)
//         ))
//         draft = draft.withMutations((d) => {
//           draft.setProcessing(d, ungraphedURLs.length > 0)
//           draft.setAttachments(d, 'og', nextOGs)
//         })

//         dispatch(actions.putDraft(
//           draftId, draft))

//         if (ungraphedURLs) {
//           const jwt = selectors.selectAuth(community)
//           const graphs = await api.openGraph({
//             apiKey: jwt.get('apiKey'),
//             token: jwt.get('token'),
//             appId: jwt.get('appId'),
//             urls: ungraphedURLs,
//           })
//           const { community: nextState } = getState()
//           draft = selectors.selectDraft(nextState, draftId, fallback)
//           draft = draft.withMutations((d) => {
//             draft.mergeAttachments(d, 'og', graphs)
//             const ogs = selectors.selectActivityOGs(d)
//             const uniqueOGs = ogs.reduce((out, og) => {
//               const url = og.get('url')
//               const index = out.findIndex(o => o.get('url') === url)
//               if (index > -1) {
//                 const existing = out.get(index)
//                 const locations = existing.get('locations', List())
//                 const nextLocations = locations.concat(
//                   og.get('locations'))
//                 const next = existing.set('locations', nextLocations)
//                 return out.set(index, next)
//               }
//               return out.push(og)
//             }, List())
//             draft.setAttachments(d, 'og', uniqueOGs)
//             draft.setProcessing(d, false)
//             draft.setObject(d)
//           })
//           dispatch(actions.putDraft(
//             draftId, draft))
//         }
//       }
//     })
// }


export function watchAddDraftPhotos ({ after }) {
  return after(
    actions.COMMUNITY_ADD_DRAFT_PHOTOS,
    async ({ action, getState, dispatch }) => {
      const { payload } = action
      const { draftId, photos } = payload
      // const photos = await api.prepFiles(files)

      if (photos.length) {
        const { community } = getState()

        let workingDraft = selectors.selectDraft(community, draftId)

        const images = await bluebirdMap(photos, async photo => (
          api.createDataUri(photo)
        ))

        workingDraft = workingDraft.withMutations((d) => {
          draft.addAttachments(d, 'images', images)
          // draft.setPhotosProcessing(d)
        })

        dispatch(actions.putDraft(
          draftId, workingDraft))
      }
    })
}

// export function watchDeleteDraftOpenGraph ({ after }) {
//   return after(
//     actions.COMMUNITY_DELETE_DRAFT_OPENGRAPH,
//     async ({ action, state, dispatch }) => {
//       const { payload } = action
//       const { community } = state
//       const { draftId, graphId } = payload
//       const draft = selectors.selectDraft(community, draftId)

//       if (draft) {
//         const graphs = selectors.selectActivityOGs(draft)
//         const nextGraphs = graphs.map((graph) => {
//           const id = graph.get('id')
//           if (id === graphId) {
//             return graph.set('render', false)
//           }
//           return graph
//         })
//         const nextDraft = draft.withMutations((d) => {
//           draft.setAttachments(d, 'og', nextGraphs)
//           draft.setObject(d)
//         })
//         dispatch(actions.putDraft(draftId, nextDraft))
//       }
//     })
// }

export function watchDeleteDraftAttachment ({ after }) {
  return after(
    actions.COMMUNITY_DELETE_DRAFT_ATTACHMENT,
    async ({ state, action, dispatch }) => {
      const { payload } = action
      const { community } = state
      const { draftId, attachmentId, path } = payload

      const activity = selectors.selectDraft(community, draftId)
      const next = draft.deleteAttachment(activity, path, attachmentId)

      dispatch(actions.putDraft(
        draftId, draft.setObject(next)))
    })
    .catch(() => {
      /* silent fail */
    })
}

